import { TFilterKey, TFilters } from '../components/types';
import { cleanId } from './cleanId';

/**
 * Toggle a group of items by key
 * If all items are selected, deselect them
 * If not all items are selected, select them
 *
 * This is used in Filters component to toggle a group of items by key
 *
 * @param {TFilterKey} key
 * @param {{ _id: string }[]} [group=[]]
 * @param {TFilters} currents
 * @param {(currents: TFilters) => void} setCurrents
 */
export const toggleGroupByKey = ({
    key,
    group = [],
    currents,
    setCurrents,
    category,
}: {
    key: TFilterKey;
    group: { _id: string }[];
    currents: TFilters;
    setCurrents: (currents: TFilters) => void;
    category: string;
}) => {
    const groupIds = group.map((s) => `[${category}]${s._id}`);

    const currentValue = currents[key];
    const currentValues: string[] = Array.isArray(currentValue)
        ? currentValue
        : [];

    const allSelected = groupIds.every((id) => currentValues.includes(id));

    let next: string[] = [];

    if (allSelected) {
        next = currentValues.filter((id) => !groupIds.includes(id));
    } else {
        const set = new Set(currentValues);
        groupIds.forEach((id) => set.add(id));
        next = Array.from(set);
    }

    setCurrents({
        ...currents,
        [key]: next,
    });
};
